import axios, { AxiosRequestConfig } from 'axios';

import { ApiSuccessResponse } from './types';

type Params = {
  params?: AxiosRequestConfig['params'];
  withCredentials?: AxiosRequestConfig['withCredentials'];
  signal?: AxiosRequestConfig['signal'];
  headers?: AxiosRequestConfig['headers'];
};

export function httpPost<T>(
  url: string,
  data?: AxiosRequestConfig['data'],
  params?: Params
) {
  return axios.post<ApiSuccessResponse<T>>(url, data, params);
}
